import React, { useState } from "react";
import { useCart } from "../components/cart-components/CartContext";
import DeliveryForm from "../components/checkout-components/DeliveryForm";
import CartSummary from "../components/checkout-components/CartSummary";
import PlaceOrderButton from "../components/checkout-components/PlaceOrderButton";
import "../styles.css";

const CheckoutPage = () => {
  const { cartItems, totalPrice, clearCart } = useCart();
  const [deliveryDetails, setDeliveryDetails] = useState({
    name: "",
    address: "",
    city: "",
    postalCode: "",
    phone: "",
  });
  const [orderPlaced, setOrderPlaced] = useState(false);

  const handlePlaceOrder = () => {
    if (
      deliveryDetails.name &&
      deliveryDetails.address &&
      deliveryDetails.city &&
      deliveryDetails.postalCode &&
      deliveryDetails.phone &&
      cartItems.length > 0
    ) {
      console.log("Order Details:", { deliveryDetails, cartItems, totalPrice });
      setOrderPlaced(true);
      clearCart();
    } else {
      alert("Please fill all delivery details and ensure your cart is not empty.");
    }
  };

  if (orderPlaced) {
    return (
      <div className="page-content">
        <h2>Thank You!</h2>
        <p>Your order has been placed successfully.</p>
      </div>
    );
  }

  return (
    <div className="page-content">
      <h2>Checkout</h2>
      <DeliveryForm
        deliveryDetails={deliveryDetails}
        setDeliveryDetails={setDeliveryDetails}
      />
      <CartSummary cartItems={cartItems} totalPrice={totalPrice} />
      <PlaceOrderButton handlePlaceOrder={handlePlaceOrder} />
    </div>
  );
};

export default CheckoutPage;
